import { render, staticRenderFns } from "./standalone-video.vue?vue&type=template&id=0ff9ebf4&scoped=true&"
import script from "./standalone-video.vue?vue&type=script&lang=js&"
export * from "./standalone-video.vue?vue&type=script&lang=js&"
import style0 from "./standalone-video.vue?vue&type=style&index=0&id=0ff9ebf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff9ebf4",
  null
  
)

export default component.exports